<template>
  <div class="home">
    <!--头部-->
    <div class="header">
      <img v-if="signStatus != 2" class="head_ld" src="@/assets/images/head_ld.png" alt />
      <a class="btn-tel" href="tel:4001012223">400-1012-223</a>
      <a class="btn-qdjy" href="https://m.eic.org.cn/">启德教育官网</a>
      <a class="btn-qdkt" href="https://m.eicchannel.com/">启德课堂官网</a>
      <div class="city" @click="showCity">{{ curCity }}</div>
      <!-- <button @click="libtest">插件测试</button> -->
    </div>

    <!-- 用户登录签到区 -->
    <div class="home-login" :class="{ 'home-login2': signStatus == 2 }" v-if="signStatus <= 2">
      <div class="home-login-con">
        <form id="yyform" v-if="!isLogin">
          <!-- 姓名 -->
          <p>
            <input name="name" type="text" placeholder="请输入您的姓名" class="input-txt" v-model="userLoginForm.nickname" maxlength="18" />
          </p>
          <p>
            <select v-model="userLoginForm.countryId" ref="countryId" class="country-select">
              <option value disabled selected>请选择意向国家/地区</option>
              <option v-for="(item, index) in countryList" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
          </p>
          <!-- 选择区号 -->
          <div :class="isShowCountryCode ? 'namepos on' : 'namepos'" @click="showCountryCode()">
            <span class="country-name elips">{{ countryName }}</span>
            <span class="country-code">+{{ countryCode }}</span>
          </div>
          <!-- 区号弹窗 -->
          <div class="country-code-box" v-show="isShowCountryCode">
            <span v-for="(item, index) in countryCodeList" :key="index" @click="selectCountry(item.cn, item.code)">
              <i>{{ item.cn }}</i>
              <s>+{{ item.code }}</s>
            </span>
          </div>

          <!-- 手机号 -->
          <p>
            <input name="mobile" type="number" placeholder="请输入您的手机号" class="input-txt phone-tel" v-model="userLoginForm.mobile" ref="mobile" oninput="if(value.length>11)value=value.slice(0,11)" />
          </p>

          <!-- 验证码 -->
          <p>
            <input type="number" placeholder="请输入手机验证码" class="input-txt phone-code" v-model="userLoginForm.code" oninput="if(value.length>6)value=value.slice(0,6)" />
            <button type="button" class="yy-form-yzm get-code" :class="{ 'get-code-isDisable': userFormFunc.isDisable }" @click="userCodeValiate" :disabled="userFormFunc.isDisable">{{ userFormFunc.codeText }}</button>
          </p>
          <!-- 立即签到 -->
          <p>
            <input type="button" class="yy-form-btn" value="马上预约" @click="userFormSubmit" v-if="signStatus < 2" />

            <input type="button" class="yy-form-btn" value="马上签到" @click="userFormSubmit" v-if="signStatus == 2" />
          </p>
        </form>
        <p v-if="!isLogin" class="login-from-des" style=" color: #ffffff;
        font-size: 0.2rem;
        text-align: center;
        margin-top: -0.18rem;
      }">*预约后，我们的客服将尽快进行电话回访，确认您的预约需求。</p>

        <!-- 预约成功（签到成功） -->
        <div class="succ" v-if="isLogin">
          <p class="succ-phone">用户{{ userFormFunc.telInfo }}</p>
          <div class="login-txt" v-if="signStatus < 2">
            <img src="@/assets/images/login_succ1.png" alt="您已经预约成功" />
          </div>
          <div class="login-txt" v-if="signStatus == 2">
            <img src="@/assets/images/login_succ2.png" alt="您已经签到成功" />
          </div>
          <!-- <h6 v-if="signStatus < 2">您已经预约成功</h6>
          <h6 v-if="signStatus == 2">您已经签到成功</h6>-->
        </div>
      </div>
    </div>

    <!-- 签到区活动结束 -->
    <div class="home-login" v-if="signStatus > 2">
      <div class="home-login-con">
        <!-- <h3>展会签到区</h3> -->
        <form id="yyform" style="padding-top: 1rem">
          <!-- <h3>预约区</h3> -->
          <div class="login-img">
            <img class="sign-end-img" src="@/assets/images/login_fail.png" alt="活动已结束" />
          </div>
          <p class="over">您可以关注启德课堂其他直播活动或者视频</p>
        </form>
      </div>
    </div>

    <!-- 邀请好友签到 -->
    <!-- <div class="home-yqhy">
      <a href="javascript:;">
        <img src="@/assets/images/yqhy_ad.png" alt="邀请好友签到 逛展中大奖" />
      </a>
    </div>-->

    <!-- 广告区 -->
    <!-- <div class="home-ad1" v-if="upAdv">
      <a :href="upAdv.url">
        <img :src="upAdv.image" alt />
      </a>
    </div>-->
    <!--头部 end-->

    <!-- 2 官方发布区 -->
    <Official :isLogin="isLogin" @showLogin="showLogin" ref="official" :expoId="expoId" />

    <!-- 3 直播频道-->
    <Live :isLogin="isLogin" @showLogin="showLogin" ref="live" :expoId="expoId" />

    <!-- 4 院校咨询 -->
    <School :isLogin="isLogin" @showLogin="showLogin" ref="adviser" :expoId="expoId" />

    <!-- 5.大咖咨询 -->
    <Exam :isLogin="isLogin" @showLogin="showLogin" :expoId="expoId" ref="exam" />

    <!-- 6 教育顾问咨询 -->
    <Teacher :isLogin="isLogin" :adviserStatus="Number(adviserStatus)" :expoId="expoId" @showLogin="showLogin" :curCity="curCity" :partStartTime="partStartTime" ref="teacher" />

    <!-- 逛展抽奖 -->
    <Prize :isLogin="isLogin" :prizeStatus="prizeStatus" :partStartTime="partStartTime" @showLogin="showLogin" :downAdv="downAdv ? downAdv : {}" :expoId="expoId" ref="prize" />

    <!-- 签约抽奖 -->
    <Signprize :isLogin="isLogin" :signPrizeStatus="signPrizeStatus" @showLogin="showLogin" :expoId="expoId" ref="signprize" />

    <!-- 底部 -->
    <!-- <Footer /> -->

    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" :signStatus="signStatus" :prizeStatus="prizeStatus" @closeLogin="isShowLogin = false" @success="loginSuccess" :expoId="expoId" />

    <!-- 城市定位弹框 -->
    <CityAds @chageCurcity="changeCurcity" ref="cityAds" :expoId="expoId" />

    <!-- 底部导航 -->
    <footerNav />

    <!-- 右侧导航 -->
    <Float />

    <!-- 登录成功后7月18日之后弹出 专属豪礼弹窗 -->
    <div class="tc-bg2" v-if="zshlShow">
      <div class="tc">
        <img src="@/assets/images/home_qdyl.png" />
        <span @click="close" class="close" style="height: 0.52rem; bottom: -4.2rem; width: 2rem; background: 0">免费领取</span>
      </div>
    </div>

    <!-- 登录成功后8月15日之前弹出 教育展开幕提醒 -->
    <div class="tc-bg2" v-if="kmtxShow">
      <div class="tc">
        <img src="@/assets/images/home_kmtx.png" />
        <span @click="close" class="close">关闭</span>
      </div>
    </div>
  </div>
</template>

<script>
import Official from "@/views/home/Official.vue";
import Live from "@/views/home/Live.vue";
import School from "@/views/home/School.vue";
import Exam from "@/views/home/exam.vue";
import Teacher from "@/views/home/teacher.vue";
import Prize from "@/views/home/prize.vue";
import Signprize from "@/views/home/signprize.vue";
import CityAds from "../components/city-ads.vue";
import Login from "../components/login.vue";
import footerNav from "../components/footer_nav.vue";
// import Footer from "../components/footer.vue";
import Float from "../components/float.vue";
import {
  sendCode,
  login,
  userLoginStatus,
  getAdv,
  signActivity,
  getExpoInfo,
  getDrawTime,
  getCityList,
} from "@/api/home";
import { mapState, mapMutations } from "vuex";
import { getQueryString } from "@/assets/js/login.js";
// import { getTimeStatus } from "@/utils/utils";
import moment from "moment";

export default {
  name: "Home",
  components: {
    Official,
    Live,
    School,
    Exam,
    Teacher,
    Prize,
    Signprize,
    CityAds,
    Login,
    footerNav,
    // Footer,
    Float,
  },
  data() {
    return {
      zshlShow: false, //专属豪礼状态
      kmtxShow: false, //开幕提醒状态
      userLoginForm: {
        mobile: "", // 手机号
        code: "", // 手机验证码
        countryId: "", // 选中意向国家/地区ID/
        nickname: "", //姓名
      },
      countryList: [], // 意向国家/地区
      countryCode: 86, // 国家区号
      countryName: "中国", //国家名称
      countryCodeList: [], // 手机号码归属国家区号

      userFormFunc: {
        codeText: "获取验证码",
        telInfo: "",
        isDisable: false,
        isSubmitDisable: false,
        iSucc: false,
      },
      isLogin: false, // 是否登录
      isShowLogin: false,
      isShowCity: true,
      isShowCountryCode: false,
      curCity: "",
      cityList: [],
      timeId: null,
      // timeStatus: 0,
      drawCount: null, //抽奖次数
      upAdv: "", // 顶部广告
      downAdv: {}, // 底部广告
      refName: "",
      inviteShow: false,
      expoId: 0, // 全局活动id
      signStatus: 0, //活动时间状态
      prizeStatus: 0, //逛展抽奖时间状态
      signPrizeStatus: 0, //签约抽奖时间状态
      adviserStatus: 0, //顾问预约时间状态
      partStartTime: 0, //签约抽奖时间戳
      signStartTime: 0, //活动开始时间戳
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["login"]),
    // 关闭弹窗
    close() {
      this.zshlShow = false; //专属豪礼状态
      this.kmtxShow = false; //开幕提醒状态
    },
    // 点击获取验证码
    async userCodeValiate() {
      if (this.isDisable) {
        return;
      }
      const phoneTel = this.userLoginForm.mobile;
      // const telPartton = /^1\d{10}$/;
      if (phoneTel == "" || phoneTel == "请输入手机号") {
        alert("请输入您的手机号！");
        this.$refs.mobile.focus();
        return false;
      }

      if (!this.countryCode) {
        alert("手机验证码不能为空");
        this.$refs.mobile.focus();
        return false;
      }
      this.userFormFunc.isDisable = true; //点击后立即disable
      const res = await sendCode({
        params: {
          mobile: this.userLoginForm.mobile,
          countryCode: this.countryCode,
        },
      });
      if (!res.succ) {
        alert(res.msg);
        this.userFormFunc.isDisable = false; //验证码获取失败取消disable
      } else {
        let amount = 59;
        let timer = setInterval(() => {
          if (amount <= 0) {
            this.userFormFunc.codeText = "重新获取";
            this.userFormFunc.isDisable = false;
            clearInterval(timer);
          } else {
            this.userFormFunc.codeText = amount--;
          }
        }, 1000);
      }
    },

    // 点击提交表单
    async userFormSubmit() {
      if (this.userFormFunc.isSubmitDisable) {
        return;
      }
      var that = this;
      let phoneTel = that.userLoginForm.mobile;
      let countryId = that.userLoginForm.countryId;
      let nickname = that.userLoginForm.nickname;
      let code = that.userLoginForm.code;
      if (nickname == "") {
        alert("请输入您的姓名！");
        return false;
      }

      if (!countryId) {
        alert("请选择意向国家/地区！");
        return false;
      }
      if (phoneTel == "" || phoneTel == "请输入手机号") {
        alert("请输入您的手机号！");
        that.$refs.mobile.focus();
        return false;
      }
      if (!code) {
        alert("请输入验证码");
        return false;
      }
      if (code.length < 6) {
        alert("验证码格式");
        return false;
      }

      that.userFormFunc.isSubmitDisable = true; //提交按钮可用
      this.userLoginForm.countryCode = this.countryCode;
      let res;
      res = await login(this.userLoginForm);
      console.log(res);
      if (!res.succ) {
        alert(res.msg);
        that.userFormFunc.isSubmitDisable = false; //提交按钮可用
      } else {
        // 登录成功
        if (this.signStatus == 1) {
          this.kmtxShow = true;
        }
        if (this.signStatus == 2) {
          this.getSign(); //调用签到接口
          // this.zshlShow = true; //显示免费领券弹出层
        }
        // 逛展抽奖开始后存储当前登录时间
        window.localStorage.setItem("loginTime", Date.now());
        this.isLogin = true;
        this.getTimes(); //签到成功,抽奖次数+1
        that.userFormFunc.iSucc = true; //显示成功
        that.userFormFunc.telInfo = res.results;
        that.userFormFunc.isSubmitDisable = true; //提交按钮不可用
      }
    },

    // 判断用户是否已经登录
    async userIsLogin() {
      const res = await userLoginStatus();
      if (!res.succ) {
        // 用户未登录
        this.isLogin = false;
        window.localStorage.removeItem("loginTime");
      } else {
        // 用户从其它平台登录后，判断是否有登录时间，没有需要重新写入
        if (!window.localStorage.getItem("loginTime")) {
          window.localStorage.setItem("loginTime", Date.now());
        }
        // 用户已登录
        this.isLogin = true;
        this.userFormFunc.iSucc = true; //显示成功
        this.userFormFunc.telInfo = res.results;
        if (this.signStatus == 2) {
          this.getSign();
        }
        this.getTimes(); //签到成功,抽奖次数+1
      }
    },

    //判断用户是否从H5专题带Ticket来的，自动登录
    //同时页面锚点定位到大咖咨询区
    async isExitTicket() {
      var that = this;
      let ticket = getQueryString("ticket");
      if (ticket != null) {
        let res = await login({
          ticket,
        });
        if (res.succ) {
          if (this.signStatus == 1) {
            this.kmtxShow = true;
          }
          if (this.signStatus == 2) {
            this.getSign(); //调用签到接口
            // this.zshlShow = true;
          }
          // 用户从其它平台登录后，判断是否有登录时间，没有需要重新写入
          if (!window.localStorage.getItem("loginTime")) {
            window.localStorage.setItem("loginTime", Date.now());
          }
          this.isLogin = true;
          this.getTimes(); //签到成功,抽奖次数+1
          that.userFormFunc.iSucc = true; //显示成功
          that.userFormFunc.telInfo = res.results;
          window.location.href = "#expert"; //锚点定位到大咖咨询区
        }
      }
    },

    loginSuccess() {
      this.isLogin = true;
      this.isShowLogin = false;
      this.userIsLogin();
      this.$nextTick(() => {
        if (this.refName == "live") {
          this.$refs.live.toLive();
        } else if (this.refName == "currLive") {
          this.$refs.live.toLive2();
        } else if (this.refName == "adviser") {
          this.$refs.adviser.tips();
        } else if (this.refName == "exam") {
          this.$refs.exam.tips();
        } else if (this.refName == "teacher") {
          this.$refs.teacher.appointment();
        } else if (this.refName == "official") {
          this.$refs.official.toLive();
        } else if (this.refName == "prize") {
          this.$refs.prize.toDrawHistory();
        } else if (this.refName == "prizeBtn") {
          this.$refs.prize.start();
        } else if (this.refName == "signprize") {
          this.$refs.signprize.toDrawHistory();
        } else if (this.refName == "signprizeBtn") {
          this.$refs.signprize.getQyPrize();
        }
      });
    },

    // 调用签到接口
    async getSign() {
      const res = await signActivity({
        expoId: this.expoId,
      });
      if (res.succ) {
        this.getTimes(); //签到成功,抽奖次数+1
      }
    },

    // 获取广告
    async getAdv() {
      const res = await getAdv({
        params: {
          expoId: this.expoId,
          city: this.curCity,
        },
      });
      if (res.succ) {
        this.downAdv = res.results.find((item) => item.tag == "yd");
      }
    },

    // 打开城市弹框
    showCity() {
      this.$refs.cityAds.iShowCity = true;
      this.$refs.cityAds.isChooseCity = true;
      this.$refs.cityAds.curCity = localStorage.getItem("cityName");
      this.$refs.cityAds.id = localStorage.getItem("cityId");
      for (let i = 0; i < this.cityList.length; i++) {
        if (localStorage.getItem("cityName") == this.cityList[i].name) {
          // console.log(i)
          this.$refs.cityAds.flag = i;
        }
      }
    },

    // 获取城市列表
    async getCityList() {
      var res = await getCityList({});
      if (res.succ) {
        this.cityList = res.results;
      }
    },

    // 当前城市改变
    changeCurcity(val) {
      console.log(val);
      this.curCity = val;
    },

    // 打开登陆框
    showLogin(refName) {
      console.log("refName", refName);
      this.isShowLogin = true;
      this.refName = refName;
    },

    // 获取活动时间
    async getActivityInfo() {
      const res = await getExpoInfo({
        params: {
          name: "expo_business_202104_m",
        },
      });
      console.log(res);
      if (res.succ) {
        const {
          expoId,
          signStatus,
          participateDrawStatus,
          contractDrawStatus,
          adviserSubscribeStatus,
          signStartTime,
          partStartTime,
        } = res.results;
        this.expoId = Number(expoId);
        this.signStatus = signStatus;
        this.prizeStatus = participateDrawStatus;
        this.signPrizeStatus = contractDrawStatus;
        this.adviserStatus = adviserSubscribeStatus;
        this.signStartTime = parseInt(signStartTime); //活动开始时间戳
        this.partStartTime = parseInt(partStartTime); //逛展抽奖时间戳

        // this.signStatus = 1;
        // this.prizeStatus = 1;
        // this.signPrizeStatus = 1;
        // this.adviserStatus = 1;

        // this.signStatus = 2;
        // this.prizeStatus = 2;
        // this.signPrizeStatus = 2;
        // this.adviserStatus = 2;

        // this.signStatus = 3;
        // this.prizeStatus = 3;
        // this.signPrizeStatus = 3;
        // this.adviserStatus = 3;
      }
    },

    // 获取抽奖次数
    async getTimes() {
      const res = await getDrawTime({
        params: {
          expoId: this.expoId,
        },
      });
      if (res.succ) {
        this.drawCount = res.results.drawTime;
      }
    },

    //获取国家列表
    getCountryList() {
      let baseUrl = "/aec"; // 代理
      if (
        window.location.hostname == "m0.eicchannel.com" ||
        window.location.hostname == "m.eicchannel.com"
      ) {
        baseUrl = "https://api-kt.eiceducation.com.cn";
      }

      this.$axios
        .get(baseUrl + "/country/getCountryList")
        .then((res) => {
          if (res.data.succ) {
            let list = [];
            list = res.data.results;
            //console.log(res);
            for (let i = 0; i < list.length; i++) {
              if (list[i].name == "未确定") {
                list[i].name = "其他";
              }
            }
            this.countryList = list;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //手机号码归属国家区号
    getCountryCodeList() {
      let baseUrl = "/aec"; // 代理
      if (
        window.location.hostname == "m0.eicchannel.com" ||
        window.location.hostname == "m.eicchannel.com"
      ) {
        baseUrl = "https://api-kt.eiceducation.com.cn";
      }
      this.$axios
        .get(baseUrl + "/country/getCountryCodeList")
        .then((res) => {
          //console.log(res);
          if (res.data.succ) {
            let codeList = [];
            codeList = res.data.results;
            this.countryCodeList = codeList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //用户选择国家
    selectCountry(name, code) {
      this.countryName = name;
      this.countryCode = code;
      this.isShowCountryCode = false;
    },
    //用户下拉显示国家区号列表
    showCountryCode() {
      this.isShowCountryCode = !this.isShowCountryCode;
    },

    // 倒计时
    // countDown() {
    //   const moment = require("moment");
    //   moment.suppressDeprecationWarnings = true;
    //   const start = moment(
    //     parseInt(this.signStartTime * 1000 + 86400000 - 32400000)
    //   ).format("YYYY/MM/DD HH:mm:ss");
    //   const login = moment(new Date().getTime()).format("YYYY/MM/DD HH:mm:ss");
    //   this.activityCountdown = moment(start).diff(moment(login), "days");
    // },
    // 方法
    // 参数1：活动当天时间状态
    // 参数2：时间戳
    // 参数3：回调函数
    watchStatus(statusName, timeStamp, type) {
      if (this[statusName] >= 2) return; //代表已经进入活动时间内了
      if (
        parseInt(new Date().getTime()) < parseInt(timeStamp * 1000 - 32400000)
      )
        return; //只在活动当天0点之后才会调用定时器
      let time = setInterval(() => {
        // 时间到达后立即切换为活动中
        if (parseInt(new Date().getTime()) > parseInt(timeStamp * 1000)) {
          clearInterval(time);
          this[statusName] = 2;
          if (this.isLogin) {
            if (type == 1) {
              this.getSign();
            }
            if (type == 2) {
              this.$refs.prize.initInterval();
              this.$refs.prize.timeWatching();
              this.$refs.prize.getTimes();
            }
            if (type == 3) {
              this.$refs.signprize.getTimes();
            }
          }
        }
      }, 1000);
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.setAttribute("src", "https://cdn.eiceducation.com.cn/js/live800.js");
    document.body.appendChild(script);
  },
  async created() {
    this.getActivityInfo();
    this.getCountryList();
    this.getCountryCodeList();
    // this.initTime();
    this.userIsLogin();
    this.isExitTicket();
    this.getCityList();
  },
  watch: {
    expoId() {
      if (localStorage.getItem("cityName")) {
        this.getAdv();
      }
      this.watchStatus("signStatus", this.signStartTime, 1); //监听顶部签到开始时间
      this.watchStatus("prizeStatus", this.partStartTime, 2); //监听逛展抽奖开始时间
      this.watchStatus("signPrizeStatus", this.contStartTime); //监听签约抽奖开始时间
    },
    curCity() {
      if (this.expoId != 0) {
        this.getAdv();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  background: #0358dd url(~@/assets/images/head.jpg) no-repeat top;
  background-size: 100% auto;
  padding-top: 6.04rem;
  position: relative;
  // 头部
  .header {
    padding-top: 0.24rem;
    a {
      height: 0.5rem;
      display: block;
      position: absolute;
      &.btn-tel {
        width: 2.2rem;
        top: 0.4rem;
        right: 1.2rem;
        text-indent: -9999px;
      }
      &.btn-qdjy {
        width: 1.7rem;
        top: 0.4rem;
        left: 0rem;
        text-indent: -9999px;
      }
      &.btn-qdkt {
        width: 1.5rem;
        top: 0.4rem;
        left: 1.8rem;
        text-indent: -9999px;
      }
    }

    .city {
      position: absolute;
      left: 6.5rem;
      top: 0.32rem;
      color: #fff;
      font-size: 0.24rem;
      width: 0.57rem;
      white-space: nowrap;
      text-align: center;
      font-weight: 500;
    }
  }

  // 登录区

  .home-login {
    background: url(~@/assets/images/from_tit1.png) no-repeat center;
    background-size: 100% 100%;
    width: 6.9rem;
    height: 6.2rem;
    margin: 0.4rem auto 0.4rem;
    &.home-login2 {
      background: url(~@/assets/images/from_tit2.png) no-repeat center;
      background-size: 100% 100%;
    }
    .home-login-con {
      height: 4.4rem;
      position: relative;
      padding-top: 0.9rem;
      #yyform {
        padding: 0.23rem 0.5rem 0.1rem;
        position: relative;
        border-radius: 0.24rem;
        p {
          height: 0.7rem;
          margin-bottom: 0.2rem;
          .input-txt {
            width: 100%;
            height: 0.7rem;
            display: block;
            border-radius: 0.28rem;
            padding: 0 0.3rem 0 0.65rem;
            box-sizing: border-box;
            font-size: 0.26rem;
            line-height: 0.52rem;
            border: 0;
            background-color: #f5f7fd;
            &.phone-tel {
              padding-left: 2.5rem;
            }
            &.phone-code {
              width: 3.7rem;
              margin-right: 0.16rem;
              float: left;
            }
          }
          .get-code {
            width: 1.86rem;
            height: 0.7rem;
            display: block;
            float: left;
            border: 0;
            border-radius: 0.5rem;
            font-size: 0.26rem;
            color: #fff;
            background: #0552cb;
            font-weight: 500;
            cursor: pointer;
            outline: none;
            &.get-code-isDisable {
              background-color: #ccc;
            }
          }

          .yy-form-btn {
            width: 3.6rem;
            height: 0.7rem;
            display: block;
            border: 0;
            cursor: pointer;
            background: #f15d57;
            color: #fff;
            outline: none;
            border-radius: 0.5rem;
            font-size: 0.32rem;
            font-weight: 500;
            letter-spacing: 0.03rem;
            margin: 0rem auto;
            padding-bottom: 0.06rem;
          }
        }
        .country-select {
          width: 100%;
          display: block;
          border-radius: 0.28rem;
          padding: 0 0.3rem 0 0.65rem;
          box-sizing: border-box;
          font-size: 0.24rem;
          line-height: 0.52rem;
          border: 0;
          height: 0.7rem;
          color: #757575;
          background: #f5f7fd url(~@/assets/images/arr_select.png) no-repeat
            right center;
          background-size: 0.3rem 0.3rem;
        }

        // 区号
        .namepos {
          width: 2.2rem;
          height: 0.4rem;
          position: absolute;
          left: 0.5rem;
          top: 2.22rem;
          border-right: 1px solid #e5e5ea;
          line-height: 0.38rem;
          font-size: 0.26rem;
          color: #7e7c94;
          overflow: hidden;
          zoom: 1;
          padding-left: 0.65rem;
          background: url(~@/assets/images/arr_select2.png) 1.8rem 0.12rem
            no-repeat;
          background-size: 0.21rem auto;
          &.on {
            background: url(~@/assets/images/arr_select2a.png) 1.8rem 0.12rem
              no-repeat;
            background-size: 0.21rem auto;
            .country-name {
              width: 30%;
              display: block;
              float: left;
            }
          }
        }

        // 区号弹窗
        .country-code-box {
          width: 5.7rem;
          height: 3.5rem;
          padding: 0.1rem 0.2rem;
          border: 1px solid #cdcdcd;
          background: #fff;
          position: absolute;
          left: 0.6rem;
          top: 1.7rem;
          overflow: auto;
          border-radius: 0.1rem;
          z-index: 999;
          span {
            display: block;
            height: 0.55rem;
            border-bottom: 1px solid #eee;
            font-size: 0.24rem;
            line-height: 0.55rem;
            color: #666;
            overflow: hidden;
            zoom: 1;
            cursor: pointer;
            i {
              width: 70%;
              display: block;
              float: left;
              font-style: normal;
            }
            s {
              width: 30%;
              display: block;
              float: right;
              text-decoration: none;
              text-align: right;
            }
          }
        }
      }
      .succ {
        .succ-phone {
          line-height: 0.75rem;
          border-radius: 5rem;
          background: #f2f4f9;
          color: #000000;
          text-align: center;
          margin: 0.85rem auto 0.5rem;
          font-size: 0.26rem;
          width: 5.74rem;
          height: 0.7rem;
        }

        .login-txt {
          width: 4rem;
          margin: 0 auto 0.3rem;
          img {
            display: block;
            width: 100%;
          }
        }
      }
      .login-img {
        margin-top: 0.4rem;
        padding-left: 1.5rem;
        margin-bottom: 0.4rem;
        .sign-end-img {
          width: 2.6rem;
        }
      }
      .over {
        color: #abaeb7;
        font-size: 0.3rem;
      }
      // .login-from-des {
      //   color: #969696;
      //   font-size: 0.22rem;
      //   text-align: center;
      //   margin-top: -0.18rem;
      // }
    }
  }

  // 邀请好友签到
  .home-yqhy {
    margin: 0 0.3rem 0.4rem;
  }
}

// /*弹出层样式 */
.tc-bg2 {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
}
.tc-bg2 .tc {
  width: 6rem;
  height: 6.44rem;
  position: absolute;
  top: -2rem;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.tc-bg2 .tc .close {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 120%;
  margin: auto;
  width: 0.75rem;
  height: 0.75rem;
  box-sizing: content-box;
  text-indent: -9999px;
  background: url(~@/assets/images/pop_close_btn2.png) no-repeat center;
  background-size: 100% 100%;
}
.tc-bg2 .tc p {
  font-size: 0.24rem;
  text-align: center;
  padding: 0.3rem 0.3rem;
}

//火狐下的移除
input[type="number"] {
  -moz-appearance: textfield;
}

//谷歌下的移除
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
</style>
